import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService.js';

/**
 * Filtro por categoría de mueble.
 *
 * Vive acá y no en Common/FilterCustom a propósito: ese componente lo comparten
 * muchas pantallas y agregarle un filtro que solo usa el control de muebles lo
 * ensuciaría para todas.
 *
 * Trae las categorías por su cuenta y avisa hacia arriba con getValue. La "x"
 * de limpiar la pone el propio Autocomplete: al borrar manda null, que el padre
 * traduce a "sin filtro".
 */
export default function FilterFurnitureCategory({ value, getValue, getData }) {
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(null);

  async function loadCategories() {
    let response = await wsGetAll('base/furniture-sales-category');
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    loadCategories();
  }, []);

  //si el padre limpia los filtros, el combo se limpia con él
  useEffect(() => {
    if (!value?.base_furniture_sales_category_id) setSelected(null);
  }, [value]);

  return (
    <GridItem xs={12} lg={3}>
      <Autocomplete
        options={categories}
        value={selected}
        getOptionLabel={(option) => option.description || ''}
        getOptionSelected={(option, val) => option.id === val.id}
        renderInput={(params) => (
          <TextField {...params} placeholder="Categoría" margin="normal" fullWidth />
        )}
        onChange={(e, item) => {
          setSelected(item);
          const nuevo = { ...value, base_furniture_sales_category_id: item ? item.id : undefined };
          if (!item) delete nuevo.base_furniture_sales_category_id;
          getValue(nuevo);
          //se consulta al instante: es un combo, no hay nada que terminar de escribir
          getData(nuevo);
        }}
      />
    </GridItem>
  );
}
